<template>
	<div class="vu-upload-avatar"> 
		<el-upload
			class="avatar-uploader"
			:action="`${apiPrefix}${uploadUrl}`"
			:headers="headers"
			:show-file-list="false"
			:data="{ type:'avatar' }"
			accept="image/*"
			:on-success="handleAvatarSuccess"
			:on-preview="handlePictureCardPreview"
			:before-upload="beforeAvatarUpload">
			<img v-if="modelValue" :src="modelValue" class="avatar-uploader-image" :style="{
				'height': `${height}px`,
				'width': `${width}px`
			}" />
			<el-icon v-else class="avatar-uploader-icon" :style="{
				'height': `${height}px`,
				'width': `${width}px`
			}" >
				<Plus />
			</el-icon>
		</el-upload>
		
		<el-dialog v-model="dialogVisible">
		    <img w-full :src="dialogImageUrl" alt="图片预览" />
		</el-dialog>
	</div>
</template>

<script setup>
	import { useMessage } from '@/utils/message'
	import { useStorage } from '@/utils/storage'
	
	const props = defineProps({
		modelValue: { type: String },
		uploadUrl: { type: String, required: true },
		height: { type: Number, default: 100 },
		width: { type: Number, default: 100 },
		headers: { type: Object, default: () =>({}) }
	})
	
	const apiPrefix = import.meta.env.VITE_APP_API_BASE;
	
	const emits = defineEmits(['update:modelValue'])
	
	const dialogVisible = ref(false)
	const dialogImageUrl = ref('')
	
	const { headers } = toRefs(props)
	const token = useStorage('local').get('user-token')
	if(token) {
		headers.value['TOKEN'] = token
	}
	
	const handleAvatarSuccess = (res) => {
		if(res.code != 0) {
			return useMessage('上传失败').show('error')
		}
		const { url } = res.data
		useMessage('上传成功').show('success')
		emits('update:modelValue', url)
	}
	
	const handlePictureCardPreview = (file) => {
		dialogImageUrl.value = file.url
		dialogVisible.value = true
	}
	
	const beforeAvatarUpload = () => {
		
	}
</script>

<style lang="scss" scoped>
	.vu-upload-avatar {
		
		.avatar-uploader {
			border: 1px dashed var(--el-border-color);
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			transition: var(--el-transition-duration-fast);
			
				
			&:hover {
				border-color: var(--el-color-primary);
			}
			
			.avatar-uploader-image { 
				display: block;
			}
			
			.avatar-uploader-icon {
			  font-size: 28px;
			  color: #8c939d;
			  text-align: center;
			} 
		}
	}
</style>